/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_EntityInputs */

const cs_audit_entity = /** @type {(inputs: Audit_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entita`)
};

const en_audit_entity = /** @type {(inputs: Audit_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity`)
};

/**
* | output |
* | --- |
* | "Entity" |
*
* @param {Audit_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_entity = /** @type {((inputs?: Audit_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_entity(inputs)
	return cs_audit_entity(inputs)
});